import { AngularFirestore, AngularFirestoreCollection } from '@angular/fire/firestore';
import { Observable, Subject } from 'rxjs';
import { Injectable } from '@angular/core';
import { FirestoreRange } from '../interfaces/firestore-range';
import { switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class FirestoreProductsService {

  public productsCollection: AngularFirestoreCollection<FirestoreRange>;
  public products: Observable<FirestoreRange[]>;
  public productSubject = new Subject<string>();
  public productObs: Observable<FirestoreRange[]>;

  constructor(
    private database: AngularFirestore
  ) {
    this.productsCollection = this.database.collection<FirestoreRange>('product-range');
  }

  public filterBy(key: string, value: string): Observable<FirestoreRange[]> {
    this.productsCollection = this.database.collection<FirestoreRange>('product-range', document => document.where(key, '==', value));
    this.products = this.productsCollection.valueChanges();
    return this.products;
  }

  public getProducts(): Observable<FirestoreRange[]> {
    this.productsCollection = this.database.collection<FirestoreRange>('product-range');
    this.products = this.productsCollection.valueChanges();
    return this.products;
  }

  public skuListener(): Observable<string> {
    return this.productSubject.asObservable();
  }

  public skuWatch(skuParam: string) {
    this.productObs.pipe(
      switchMap(sku => this.database.collection<FirestoreRange>('products', ref => ref.where('sku', '==', skuParam)).valueChanges()
    ));
  }
}
